import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faPaperPlane, 
    faPlaneCircleXmark, 
    faPlaneDeparture,
    faPlaneArrival,
    faPlane,
    faWifi,
    faChevronDown,
    faChevronUp,
    faUsers,
    faGasPump,
    faCog,
    faCheckCircle,
    faCircle,
    faMapMarkedAlt,
    faFileAlt,
    faShareAlt,
    faRoute
} from "@fortawesome/free-solid-svg-icons";
import api from "../../api/api";
import "./free-mode.scss";

const aircraftTypes = [
    { code: "A225", name: "Antonov AN-225" },
    { code: "A306", name: "A300B4-600" },
    { code: "A3ST", name: "A300F4-608ST" },
    { code: "A30B", name: "A300B4-200" },
    { code: "A30F", name: "A300F4-600R" },
    { code: "A310", name: "A310-304" },
    { code: "A318", name: "A318-100" },
    { code: "A319", name: "A319-100" },
    { code: "A320", name: "A320-200" },
    { code: "A20N", name: "A320-251N" },
    { code: "A321", name: "A321-200" },
    { code: "A21N", name: "A321-251N" },
    { code: "A332", name: "A330-200" },
    { code: "A333", name: "A330-300" },
    { code: "A338", name: "A330-800" },
    { code: "A339", name: "A330-900" },
    { code: "A342", name: "A340-200" },
    { code: "A343", name: "A340-300" },
    { code: "A345", name: "A340-500" },
    { code: "A346", name: "A340-600" },
    { code: "A359", name: "A350-900" },
    { code: "A35K", name: "A350-1000" },
    { code: "A388", name: "A380-800" },
    { code: "AEST", name: "Aerostar 600" },
    { code: "AT43", name: "ATR-42-300" },
    { code: "AT45", name: "ATR-42-500" },
    { code: "AT46", name: "ATR-42-600" },
    { code: "AT72", name: "ATR-72-201" },
    { code: "AT73", name: "ATR-72-211" },
    { code: "AT75", name: "ATR-72-500" },
    { code: "AT76", name: "ATR-72-600" },
    { code: "B190", name: "B1900D" },
    { code: "B350", name: "King Air 350" },
    { code: "B461", name: "BAe 146-100" },
    { code: "B462", name: "BAe 146-200" },
    { code: "B463", name: "BAe 146-300" },
    { code: "B703", name: "B707-320C" },
    { code: "B712", name: "B717-200" },
    { code: "B721", name: "B727-100" },
    { code: "B722", name: "B727-200" },
    { code: "B732", name: "B737-200" },
    { code: "B733", name: "B737-300" },
    { code: "B734", name: "B737-400" },
    { code: "B735", name: "B737-500" },
    { code: "B736", name: "B737-600" },
    { code: "B737", name: "B737-700" },
    { code: "BBJ1", name: "B737 BBJ" },
    { code: "B738", name: "B737-800" },
    { code: "BBJ2", name: "B737 BBJ2" },
    { code: "B38M", name: "B737 MAX 8" },
    { code: "B739", name: "B737-900" },
    { code: "BBJ3", name: "B737 BBJ3" },
    { code: "B742", name: "B747-200B" },
    { code: "B744", name: "B747-400" },
    { code: "B74F", name: "B747-400F" },
    { code: "B748", name: "B747-8" },
    { code: "B48F", name: "B747-8F" },
    { code: "B752", name: "B757-200" },
    { code: "B75F", name: "B757-200PF" },
    { code: "B753", name: "B757-300" },
    { code: "B762", name: "B767-200ER" },
    { code: "B763", name: "B767-300ER" },
    { code: "B76F", name: "B767-300F" },
    { code: "B764", name: "B767-400ER" },
    { code: "B772", name: "B777-200ER" },
    { code: "B77F", name: "B777-F" },
    { code: "B77L", name: "B777-200LR" },
    { code: "B77W", name: "B777-300ER" },
    { code: "B788", name: "B787-8" },
    { code: "B789", name: "B787-9" },
    { code: "B78X", name: "B787-10" },
    { code: "BCS1", name: "A220-100" },
    { code: "BCS3", name: "A220-300" },
    { code: "BE9L", name: "King Air C90B" },
    { code: "BE20", name: "King Air 200" },
    { code: "BE24", name: "Beechcraft C24R" },
    { code: "BE36", name: "Bonanza A36" },
    { code: "BE58", name: "Baron 58" },
    { code: "BE60", name: "Duke B60" },
    { code: "BE6G", name: "Grand Duke" },
    { code: "B60T", name: "Turbine Duke" },
    { code: "BN2P", name: "BN-2 Islander" },
    { code: "C130", name: "C-130K Hercules" },
    { code: "C160", name: "Transall C-160" },
    { code: "C17", name: "C-17A Globemaster" },
    { code: "C172", name: "Cessna 172R" },
    { code: "C182", name: "Cessna 182T" },
    { code: "R182", name: "Cessna 182RG" },
    { code: "C208", name: "Cessna 208B" },
    { code: "C25A", name: "Citation CJ2" },
    { code: "C25B", name: "Citation CJ3" },
    { code: "C25C", name: "Citation CJ4" },
    { code: "C310", name: "Cessna 310R" },
    { code: "C337", name: "Cessna 337H" },
    { code: "C404", name: "C404 Titan" },
    { code: "C408", name: "Cessna 408" },
    { code: "C414", name: "Cessna 414AW" },
    { code: "C46", name: "Curtiss C-46D" },
    { code: "C510", name: "C510 Mustang" },
    { code: "C550", name: "Citation II" },
    { code: "C56X", name: "Citation 560XL" },
    { code: "C680", name: "Sovereign" },
    { code: "C700", name: "Longitude" },
    { code: "C750", name: "Citation X" },
    { code: "CL30", name: "Challenger 300" },
    { code: "CL35", name: "Challenger 350" },
    { code: "CL60", name: "Challenger 650" },
    { code: "CONI", name: "L-049" },
    { code: "CONS", name: "L-1049G" },
    { code: "CRJ2", name: "CRJ-200" },
    { code: "CRJ5", name: "CRJ-550" },
    { code: "CRJ7", name: "CRJ-700" },
    { code: "CRJ9", name: "CRJ-900" },
    { code: "CRJX", name: "CRJ-1000" },
    { code: "D328", name: "Dornier 328-100" },
    { code: "DA42", name: "Diamond DA42" },
    { code: "DA62", name: "Diamond DA62" },
    { code: "DC10", name: "DC-10-30" },
    { code: "DC3", name: "Douglas DC-3" },
    { code: "DC6", name: "Douglas DC-6" },
    { code: "DC85", name: "DC-8-55" },
    { code: "DC86", name: "DC-8-63" },
    { code: "DH8A", name: "DHC8-102" },
    { code: "DH8B", name: "DHC8-200" },
    { code: "DH8C", name: "DHC8-311" },
    { code: "DH8D", name: "DHC8-402" },
    { code: "DHC2", name: "Beaver" },
    { code: "DHC6", name: "Twin Otter" },
    { code: "DHC7", name: "Dash 7" },
    { code: "E135", name: "ERJ-135LR" },
    { code: "E13L", name: "Legacy 600" },
    { code: "E140", name: "ERJ-140LR" },
    { code: "E145", name: "ERJ-145LR" },
    { code: "E170", name: "ERJ-170" },
    { code: "E175", name: "ERJ-175" },
    { code: "E190", name: "ERJ-190" },
    { code: "E19L", name: "Lineage 1000" },
    { code: "E195", name: "ERJ-195" },
    { code: "E50P", name: "Phenom 100" },
    { code: "E55P", name: "Phenom 300" },
    { code: "EA50", name: "Eclipse 550" },
    { code: "EVAL", name: "Eviation Alice" },
    { code: "F28", name: "Fokker F28" },
    { code: "F50", name: "Fokker F50" },
    { code: "F70", name: "Fokker 70" },
    { code: "F100", name: "Fokker 100" },
    { code: "FA50", name: "Falcon 50EX" },
    { code: "FA8X", name: "Falcon 8X" },
    { code: "GLF4", name: "GLF.IV-SP" },
    { code: "H25B", name: "Hawker 800A" },
    { code: "HDJT", name: "Hondajet" },
    { code: "IL76", name: "Ilyushin IL-76" },
    { code: "JS41", name: "BAe JS-41" },
    { code: "KODI", name: "Kodiak 100" },
    { code: "L101", name: "L1011-500" },
    { code: "L410", name: "Let L-410" },
    { code: "LJ25", name: "Learjet 25" },
    { code: "LJ35", name: "Learjet 35A" },
    { code: "LJ45", name: "Learjet 45" },
    { code: "MD11", name: "MD-11" },
    { code: "MD1F", name: "MD-11F" },
    { code: "MD82", name: "DC-9-82" },
    { code: "MD83", name: "DC-9-83" },
    { code: "MD88", name: "MD-88" },
    { code: "MD90", name: "MD-90-30" },
    { code: "MU2", name: "MU-2B-60" },
    { code: "P06T", name: "Tecnam P2006T" },
    { code: "P180", name: "P.180 Avanti" },
    { code: "P212", name: "Tecnam P2012" },
    { code: "P46T", name: "Piper M500" },
    { code: "M600", name: "Piper M600" },
    { code: "PA24", name: "Piper Comanche" },
    { code: "PA34", name: "Piper Seneca" },
    { code: "PA44", name: "Piper Seminole" },
    { code: "PC12", name: "Pilatus PC12" },
    { code: "RJ70", name: "Avro RJ70" },
    { code: "RJ85", name: "Avro RJ85" },
    { code: "RJ1H", name: "Avro RJ100" },
    { code: "SB20", name: "Saab 2000" },
    { code: "SF34", name: "Saab 340B" },
    { code: "SF50", name: "Vision Jet" },
    { code: "SH33", name: "Short 330" },
    { code: "SH36", name: "Short 360" },
    { code: "SR22", name: "Cirrus SR22" },
    { code: "SR2T", name: "Cirrus SR22T" },
    { code: "STAR", name: "Starship 2000A" },
    { code: "SU95", name: "Superjet 100" },
    { code: "SW4", name: "Metroliner" },
    { code: "T134", name: "TU-134A-3" },
    { code: "T154", name: "TU-154B2" },
    { code: "T204", name: "Tu-204-100B" },
    { code: "TBM8", name: "TBM 850" },
    { code: "TBM9", name: "TBM 900" },
    { code: "VC10", name: "Vickers VC-10" },
    { code: "YK40", name: "Yak-40" }
];

export function FreeMode({ onFlightSubmit, activeFlight, initialData, isFromTour }) {
    const { t } = useTranslation();
    const location = useLocation();
    const [currentStep, setCurrentStep] = useState(1);
    const [tourInfo, setTourInfo] = useState(null);

    const [formData, setFormData] = useState({
        departureIcao: initialData?.departure || location.state?.departure || "",
        arrivalIcao: initialData?.arrival || location.state?.arrival || "",
        aircraft: "",
        network: "",
        passengers: "",
        extraFuelMinutes: ""
    });
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        if (isFromTour && initialData) {
            setTourInfo({
                tourName: initialData.tourName,
                legOrder: initialData.legOrder
            });
        }
    }, [isFromTour, initialData]);

    useEffect(() => {
        if (!activeFlight) {
            setCurrentStep(1);
        } else if (activeFlight.simbriefData) {
            setCurrentStep(3); // Has SimBrief data, ready for IVAO
        } else {
            setCurrentStep(2); // Has flight created, ready for SimBrief
        }
    }, [activeFlight]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "departureIcao" || name === "arrivalIcao") {
            setFormData((prev) => ({ ...prev, [name]: value.toUpperCase() }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);

        try {
            const response = await api.post(
                "/flights/report/free-mode",
                {
                    departureIcao: formData.departureIcao.toUpperCase(),
                    arrivalIcao: formData.arrivalIcao.toUpperCase(),
                    aircraft: formData.aircraft,
                    network: formData.network || null,
                    passengers: formData.passengers ? parseInt(formData.passengers) : null,
                    extraFuelMinutes: formData.extraFuelMinutes ? parseInt(formData.extraFuelMinutes) : null,
                },
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                }
            );

            setSuccess(t("flight-report-submitted"));
            
            // Don't clear form data so user can use it for SimBrief
            // The step will update automatically via useEffect when activeFlight updates

            if (onFlightSubmit) {
                onFlightSubmit();
            }
        } catch (error) {
            console.error(t("failed-to-submit-report"), {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            const errorMessage =
                error.response?.data?.error || error.message || t("failed-to-submit-report");
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="view-model free-mode-container">
            {/* Flight Progress Steps - Compact */}
            <div className="flight-progress-container">
                <div className={`progress-bar-container step-${currentStep}`}>
                    <div className="progress-steps">
                        <div className={`progress-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}>
                            <div className="step-icon">
                                <FontAwesomeIcon icon={currentStep > 1 ? faCheckCircle : faMapMarkedAlt} />
                            </div>
                            <span className="step-title">1. Planear</span>
                        </div>
                        
                        <div className={`progress-step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}>
                            <div className="step-icon">
                                <FontAwesomeIcon icon={currentStep > 2 ? faCheckCircle : faFileAlt} />
                            </div>
                            <span className="step-title">2. SimBrief</span>
                        </div>
                        
                        <div className={`progress-step ${currentStep >= 3 ? 'active' : ''} ${currentStep > 3 ? 'completed' : ''}`}>
                            <div className="step-icon">
                                <FontAwesomeIcon icon={currentStep > 3 ? faCheckCircle : faShareAlt} />
                            </div>
                            <span className="step-title">3. FPL</span>
                        </div>
                        
                        <div className={`progress-step ${currentStep >= 4 ? 'active' : ''} ${currentStep > 4 ? 'completed' : ''}`}>
                            <div className="step-icon">
                                <FontAwesomeIcon icon={currentStep > 4 ? faCheckCircle : faPlane} />
                            </div>
                            <span className="step-title">4. Volar</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="free-mode-header">
                <h1>
                    <FontAwesomeIcon icon={isFromTour ? faRoute : faPlaneCircleXmark} /> 
                    {isFromTour ? 'Volar Tour' : 'Generar un vuelo libre'}
                </h1>
                {tourInfo && (
                    <div className="tour-info-banner">
                        <FontAwesomeIcon icon={faRoute} />
                        <div className="tour-details">
                            <span className="tour-name">{tourInfo.tourName}</span>
                            {tourInfo.legOrder && (
                                <span className="leg-description">Etapa {tourInfo.legOrder}</span>
                            )}
                        </div>
                    </div>
                )}
            </div>
            
            <form onSubmit={handleSubmit} className="free-mode-form">
                <div className="form-section">
                    <h3 className="section-title">
                        <FontAwesomeIcon icon={faPlane} /> {t("Flight Information")}
                    </h3>
                    
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="departureIcao">
                                <FontAwesomeIcon icon={faPlaneDeparture} /> {t("departure-icao")}
                            </label>
                            <input
                                type="text"
                                id="departureIcao"
                                name="departureIcao"
                                value={formData.departureIcao}
                                onChange={handleChange}
                                required
                                maxLength={4}
                                className="icao-input"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="arrivalIcao">
                                <FontAwesomeIcon icon={faPlaneArrival} /> {t("arrival-icao")}
                            </label>
                            <input
                                type="text"
                                id="arrivalIcao"
                                name="arrivalIcao"
                                value={formData.arrivalIcao}
                                onChange={handleChange}
                                required
                                maxLength={4}
                                className="icao-input"
                            />
                        </div>
                    </div>
                    
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="aircraft">
                                <FontAwesomeIcon icon={faPlane} /> {t("aircraft-type")}
                            </label>
                        <select
                            id="aircraft"
                            name="aircraft"
                            value={formData.aircraft}
                            onChange={handleChange}
                            required
                            className="aircraft-select"
                        >
                            <option value="">{t("select-aircraft")}</option>
                            <optgroup label="Airbus">
                                {aircraftTypes.filter(a => a.code.startsWith('A')).map(aircraft => (
                                    <option key={aircraft.code} value={aircraft.code}>
                                        {aircraft.code} - {aircraft.name}
                                    </option>
                                ))}
                            </optgroup>
                            <optgroup label="Boeing">
                                {aircraftTypes.filter(a => a.code.startsWith('B')).map(aircraft => (
                                    <option key={aircraft.code} value={aircraft.code}>
                                        {aircraft.code} - {aircraft.name}
                                    </option>
                                ))}
                            </optgroup>
                            <optgroup label="Cessna">
                                {aircraftTypes.filter(a => a.code.startsWith('C') && !a.code.startsWith('CL') && !a.code.startsWith('CR') && !a.code.startsWith('CO')).map(aircraft => (
                                    <option key={aircraft.code} value={aircraft.code}>
                                        {aircraft.code} - {aircraft.name}
                                    </option>
                                ))}
                            </optgroup>
                            <optgroup label="Embraer">
                                {aircraftTypes.filter(a => a.code.startsWith('E') && !a.code.startsWith('EA') && !a.code.startsWith('EV')).map(aircraft => (
                                    <option key={aircraft.code} value={aircraft.code}>
                                        {aircraft.code} - {aircraft.name}
                                    </option>
                                ))}
                            </optgroup>
                            <optgroup label="Other">
                                {aircraftTypes.filter(a => 
                                    !a.code.startsWith('A') && 
                                    !a.code.startsWith('B') && 
                                    !a.code.startsWith('C') && 
                                    !a.code.startsWith('E') ||
                                    a.code.startsWith('CL') ||
                                    a.code.startsWith('CR') ||
                                    a.code.startsWith('CO') ||
                                    a.code.startsWith('EA') ||
                                    a.code.startsWith('EV')
                                ).map(aircraft => (
                                    <option key={aircraft.code} value={aircraft.code}>
                                        {aircraft.code} - {aircraft.name}
                                    </option>
                                ))}
                            </optgroup>
                            </select>
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="network">
                                <FontAwesomeIcon icon={faWifi} /> {t("network")}
                            </label>
                            <select
                                id="network"
                                name="network"
                                value={formData.network}
                                onChange={handleChange}
                            >
                                <option value="">{t("select-network")}</option>
                                <option value="IVAO">{t("ivao")}</option>
                                <option value="VATSIM">{t("vatsim")}</option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <div className="advanced-section">
                    <button 
                        type="button" 
                        className="advanced-toggle"
                        onClick={() => setShowAdvanced(!showAdvanced)}
                    >
                        <span>{t("Advanced Options")}</span>
                        <FontAwesomeIcon icon={showAdvanced ? faChevronUp : faChevronDown} />
                    </button>
                    
                    {showAdvanced && (
                        <div className="advanced-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="passengers">
                                        <FontAwesomeIcon icon={faUsers} /> {t("Passengers")}
                                    </label>
                                    <input
                                        type="number"
                                        id="passengers"
                                        name="passengers"
                                        value={formData.passengers}
                                        onChange={handleChange}
                                        min="0"
                                        max="850"
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label htmlFor="extraFuelMinutes">
                                        <FontAwesomeIcon icon={faGasPump} /> {t("Extra Fuel (minutes)")}
                                    </label>
                                    <input
                                        type="number"
                                        id="extraFuelMinutes"
                                        name="extraFuelMinutes"
                                        value={formData.extraFuelMinutes}
                                        onChange={handleChange}
                                        min="0"
                                        max="180"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                
                {error && <p className="error">{error}</p>}
                {success && <p className="success">{success}</p>}
                
                <div className="form-actions">
                    <button type="submit" className="btn" disabled={loading}>
                        <FontAwesomeIcon icon={faPaperPlane}/> {loading ? t("Starting...") : t("Start Flight")}
                    </button>
                </div>
            </form>
        </div>
    );
}